import { Button } from "@gravity-ui/uikit";
import Editor from "@monaco-editor/react";
import { useAction, useAtom } from "@reatom/npm-react";
import cn from "classnames";
import { editor } from "monaco-editor";
import { useCallback } from "react";
import { Helmet } from "react-helmet";
import { ProgressBar } from "src/components";
import { appConfig } from "src/config";
import { productSelectionStore } from "src/store/atoms";
import { toastHandler } from "src/util";

import { updateProductSelectionRequest } from "../ProductPage/widgets/ProductSamples/store/fetchers";
import { useSpuConverterPageTranslate } from "./hooks";
import css from "./SpuConverterPage.module.scss";
import { initialSpuLinksStore, jsonConverterSpuIdStore } from "./store";

const options: editor.IStandaloneEditorConstructionOptions = {
  minimap: {
    enabled: false,
  },
};
const optionsResultEditor: editor.IStandaloneEditorConstructionOptions = {
  readOnly: true,
  minimap: {
    enabled: false,
  },
};
export const SpuConverterPage = () => {
  const [productSelection] = useAtom(
    productSelectionStore.currentSelectionAtom,
  );

  const handleFormatClick = useAction(initialSpuLinksStore.formatAction);
  const handleAddSelected = useAction(async (ctx) => {
    const spuIds = ctx.get(jsonConverterSpuIdStore.convertedProductIdAtom);
    productSelectionStore.addSelectedIdsAction(ctx, spuIds);

    const selection = ctx.get(productSelectionStore.currentSelectionAtom);

    if (selection && selection.productIds) {
      await updateProductSelectionRequest(ctx, selection.id, {
        name: selection.name,
        productIds: [...selection.productIds, ...spuIds],
      });
    }
  });
  const [inputValue, setInputValue] = useAtom(
    initialSpuLinksStore.initialSpuLinksAtom,
  );
  const handleConvertClick = useAction((ctx) => {
    jsonConverterSpuIdStore.convertLinksToSpuIdsAsyncAction(
      ctx,
      ctx.get(initialSpuLinksStore.initialSpuLinksAtom),
    );
  });

  const [jsonConvertedSpuIds] = useAtom(
    jsonConverterSpuIdStore.jsonConvertedSpuIdAtom,
  );

  const [jsonConvertedProductIds] = useAtom(
    jsonConverterSpuIdStore.jsonConvertedProductIdAtom,
  );

  const addSelectedIdsHandle = useCallback(() => {
    handleAddSelected();
    return toastHandler.success({
      title: "Успех",
      content: "Товары успешно добавлены",
      name: "addSelectedProducts",
    });
  }, [handleAddSelected]);

  const translates = useSpuConverterPageTranslate();

  return (
    <>
      <Helmet>
        <title>{appConfig.displayName} · Консоль · Конвертер</title>
      </Helmet>
      <div className={cn(css.editorsWithGap, css.wFull, css.spaceBetween)}>
        <div className={css.codeWithTitle}>
          <div className={css.title}>{translates.linksEditorTitle}</div>
          <Editor
            height="400px"
            width="100%"
            defaultValue=""
            theme="vs-dark"
            value={inputValue}
            onChange={(e) => setInputValue(e ?? "")}
            options={options}
          />
        </div>
        <div className={css.codeWithTitle}>
          <div className={css.title}>{translates.spuIdEditorTitle}</div>
          <Editor
            height="400px"
            width="100%"
            defaultLanguage="json"
            defaultValue="[]"
            theme="vs-dark"
            value={jsonConvertedSpuIds}
            options={optionsResultEditor}
          />
        </div>
        <div className={css.codeWithTitle}>
          <div className={css.title}>{translates.productIdEditorTitle}</div>
          <Editor
            height="400px"
            width="100%"
            defaultLanguage="json"
            defaultValue="[]"
            theme="vs-dark"
            value={jsonConvertedProductIds}
            options={optionsResultEditor}
          />
        </div>
      </div>
      <div
        className={cn(css.buttonsWithGap, css.wFull, css.spaceBetween)}
        style={{ padding: "20px 0" }}
      >
        <Button
          type="button"
          view="normal"
          size="l"
          className={css.submitButton}
          onClick={handleFormatClick}
        >
          {translates.formatButton}
        </Button>
        <ProgressBar progressAtom={jsonConverterSpuIdStore.progressAtom} />
        <Button
          type="button"
          view="action"
          size="l"
          className={css.submitButton}
          onClick={handleConvertClick}
        >
          {translates.convertButton}
        </Button>
        <Button
          type="button"
          view="normal"
          size="l"
          disabled={!productSelection}
          className={css.submitButton}
          onClick={addSelectedIdsHandle}
        >
          {translates.addSelectedButton}
        </Button>
      </div>
    </>
  );
};
